// Generated by tools/gen_submodule.js 
module['exports'] = require("./lib/mediaTypes");


//////////////////
// WEBPACK FOOTER
// ../~/sportinglife-react-common/mediaTypes.js
// module id = 1635
// module chunks = 0